import React, {AriaRole, useEffect, useState} from 'react'
import {HttpClientService} from '../../../services/httpClient/httpClientService';
import {Localizer} from '../../../infrastructure/localization/localizer';
import {useAppDispatch, useAppSelector} from '../../../app/hooks';
import {
    clearSelectedLaegekompetenceMetas,
    kompetenceCardReducer,
    KompetenceCardState, scrollToActiveKompetence,
    setActiveLaegekompetenceMeta,
    setKompetenceCardStateShowCheckboxes} from '../../../pages/kompetencerPage/cards/kompetenceCardSlice';
import {LogbogLaegekompetenceApi} from '../../../services/api/logbogLaegekompetence/logbogLaegekompetenceApi';
import {EmblaIcon} from 'core/components/emblaIcon/emblaIcon';
import {LaegekompetenceMeta} from 'core/sharedmodels/kompetence/laegekompetenceMeta';
import {LaegekompetenceStatusEnum} from 'core/sharedmodels/kompetence/laegekompetenceStatusEnum';
import {NotificationModule} from "ditmer-embla";
import {FileDownloadHandler} from "../../../services/api/logbogFile/fileDownloadHandler";
import {AccountService} from "../../../services/account/accountService";
import {forloebReducer, ForloebSliceState} from "../../forloebSlice";
import {SlideIn} from "../../components/slideIn/slideIn";
import {CreateOrRemoveKlarmelding} from "../../../pages/klarmeldinger/components/createOrRemoveKlarmelding";
import {ModalType} from "../../components/slideIn/modalType";
import {KlarmeldingInputModel} from "../../../pages/klarmeldinger/components/klarmeldingInputModel";
import {ModalSize} from "../../components/slideIn/modalSize";
import {ActiveAndSelectedKompetenceList} from "../../../pages/klarmeldinger/components/activeAndSelectedKompetenceList";
import {KlarmeldingTypeEnum} from "../../../infrastructure/enums/klarmeldingTypeEnum";

const laegekompetenceApi = new LogbogLaegekompetenceApi(new HttpClientService(), new FileDownloadHandler(), new AccountService())

export interface KlarmeldButtonProps{
    klarmelderCallback?: (klarmelder: boolean) => void;
    onKlarmeldSucceeded?: (updatedLaegeKompetencer: LaegekompetenceMeta[]) => void;
    role?: AriaRole;
}

export function KlarmeldKompetenceButton(props: KlarmeldButtonProps) {
    const dispatch = useAppDispatch();
    const modalId = "klarmeldModal";

    const kompetenceCardState = useAppSelector(kompetenceCardReducer) as KompetenceCardState;
    const [isDisabledState, setIsDisabledState] = useState<boolean>(false);
    const [isKlarmeldState, setIsKlarmeldState] = useState<boolean>(true);
    const [showModal, setShowModal] = useState<boolean>(false);
    const forloebSliceState = useAppSelector(forloebReducer) as ForloebSliceState;

    const updateKompetenceStatus = async (inputModel: KlarmeldingInputModel) => {
        let laegekompetencer: LaegekompetenceMeta[] = [];

        if (kompetenceCardState.selectedLaegekompetenceMetas.length > 0) {
            if (props.klarmelderCallback) {
                props.klarmelderCallback(true);
            }
            for (const lkm of kompetenceCardState.selectedLaegekompetenceMetas) {
                let laegekompetenceModel = LaegekompetenceMeta.FromState(lkm, forloebSliceState.forloebState);
                laegekompetenceModel.status = getNewStatus();
                laegekompetencer.push(laegekompetenceModel);

                if (kompetenceCardState.selectedLaegekompetenceMetas.findIndex(lkmState => lkmState.laegekompetenceId === lkm.laegekompetenceId) > -1) {
                    dispatch(setActiveLaegekompetenceMeta(laegekompetenceModel.ToState()));
                }
            }
            const result = await laegekompetenceApi.patchStatusMultiple(laegekompetencer, inputModel.klarmeldBrugere, inputModel.klarmeldtTilAlleMedAdgang);
            
            if (result.length > 0 && props.onKlarmeldSucceeded) {
                props.onKlarmeldSucceeded(laegekompetencer);
            }

            if (props.klarmelderCallback) {
                props.klarmelderCallback(false);
            }

        } else {
            let activeKompetence = LaegekompetenceMeta.FromState(kompetenceCardState.activeLaegekompetenceMeta, forloebSliceState.forloebState);
            activeKompetence.status = getNewStatus();
            await laegekompetenceApi.patchStatus(activeKompetence, inputModel.klarmeldBrugere, inputModel.klarmeldtTilAlleMedAdgang);

            if (props.onKlarmeldSucceeded) {
                props.onKlarmeldSucceeded([activeKompetence]);
            }
            
            dispatch(setActiveLaegekompetenceMeta(activeKompetence.ToState()));
        }
        dispatch(scrollToActiveKompetence(true));

        displayNotification();

        //update state
        dispatch(clearSelectedLaegekompetenceMetas())
        dispatch(setKompetenceCardStateShowCheckboxes([]))
    }

    const displayNotification = () => {
        let count = kompetenceCardState.selectedLaegekompetenceMetas.length;
        let message = "";

        if(count === 0)
            count = 1;

        if(isKlarmeldState){
            message = Localizer.kompetencePage_kompetencerKlarmeldt(count.toString());
        }else{
            message = Localizer.kompetencePage_kompetencerKlarmeldFjernet(count.toString());
        }

        NotificationModule.showSuccess(message, "");
    }

    const getNewStatus = () => {
        return isKlarmeldState ? LaegekompetenceStatusEnum.Klarmeldt : LaegekompetenceStatusEnum.Planlagt;
    }

    useEffect(() => {
        updateIsDisabledState();
        updateIsKlarmeldState();
    }, [kompetenceCardState.activeLaegekompetenceMeta.status, kompetenceCardState.selectedLaegekompetenceMetas])

    useEffect(() => {
        updateIsDisabledState();
        updateIsKlarmeldState();
    }, [kompetenceCardState.showCheckboxOnIds])


    const updateIsDisabledState = () => {
        let isDisabled = false;

        if (kompetenceCardState.selectedLaegekompetenceMetas.length > 0 || kompetenceCardState.showCheckboxOnIds.length > 0) {
            let someHasInvalidStatus = kompetenceCardState.selectedLaegekompetenceMetas.some(lkm => !canUpdateByStatus(lkm.status));
            let someHasDifferentStatusses = kompetenceCardState.selectedLaegekompetenceMetas.findIndex(lkm => lkm.status !== kompetenceCardState.selectedLaegekompetenceMetas[0].status) > 0;
            let noKompetencerChosen = kompetenceCardState.selectedLaegekompetenceMetas.length === 0;

            isDisabled = noKompetencerChosen || someHasInvalidStatus || someHasDifferentStatusses;
        } else {
            isDisabled = !canUpdateByStatus(kompetenceCardState.activeLaegekompetenceMeta.status);
        }

        setIsDisabledState(isDisabled);
    }

    const updateIsKlarmeldState = () => {
        let isKlarmeldState = true;

        if (kompetenceCardState.selectedLaegekompetenceMetas.length > 0 || kompetenceCardState.showCheckboxOnIds.length > 0) {
            isKlarmeldState = kompetenceCardState.selectedLaegekompetenceMetas.length === 0 || kompetenceCardState.selectedLaegekompetenceMetas.some(lkm => lkm.status !== LaegekompetenceStatusEnum.Klarmeldt);
        } else {
            isKlarmeldState = kompetenceCardState.activeLaegekompetenceMeta.status !== LaegekompetenceStatusEnum.Klarmeldt;
        }

        setIsKlarmeldState(isKlarmeldState);
    }

    const canUpdateByStatus = (status: LaegekompetenceStatusEnum) => {
        return status !== LaegekompetenceStatusEnum.Godkendt
    }

    const actionText = isKlarmeldState ? Localizer.global_klarmeld() : Localizer.global_removeKlarmeld()
    

    const render = (
        <>
            <button 
                className={`btn ${isKlarmeldState ? "btn-primary" : "btn-default"}`} 
                onClick={() => setShowModal(true)} 
                data-toggle="modal" 
                data-target={`#${modalId}`} 
                disabled={isDisabledState} 
                role={props.role}
                aria-label={actionText}
            >
                <EmblaIcon iconName={isKlarmeldState ? "success" : "remove"} /> {actionText}
            </button>

            {showModal &&
                <SlideIn id={modalId}
                         title={actionText}
                         actionOnCloseCallback={() => setShowModal(false)}
                         actionFinishedCallback={() => setShowModal(false)}
                         defaultOpen={true}
                         modalSize={ModalSize.md}
                         modalType={ModalType.originalModal}
                         bodyContent={
                             <CreateOrRemoveKlarmelding modalId={modalId}
                                                        isKlarmeldState={isKlarmeldState}
                                                        updateStatusCallback={(inputModel: KlarmeldingInputModel) => updateKompetenceStatus(inputModel)}
                                                        klarmeldingType={KlarmeldingTypeEnum.Laegekompetence}>
                                 {isKlarmeldState
                                     ?
                                     <>
                                         <p>{kompetenceCardState.selectedLaegekompetenceMetas?.length > 1 ? Localizer.global_klarmeldChosenKompetencer() : Localizer.global_klarmeldChosenKompetence()}:</p>
                                         <ActiveAndSelectedKompetenceList/>
                                     </>
                                     :
                                     <>
                                         <p>{kompetenceCardState.selectedLaegekompetenceMetas?.length > 1 ? Localizer.global_removeKlarmeldFromChosenKompetencer() : Localizer.global_removeKlarmeldFromChosenKompetence()}:</p>
                                         <ActiveAndSelectedKompetenceList/>
                                     </>
                                 }

                             </CreateOrRemoveKlarmelding>}
                />
            }
        </>
    )

    return <>{render}</>
}
